export default function PlacowkiModal({
	isOpen,
	editingItem,
	formName,
	setFormName,
	formAdres,
	setFormAdres,
	formMiastoId,
	formMiastoName,
	onOpenMiastoSelect,
	formGminaId,
	formGminaName,
	onOpenGminaSelect,
	formPowiatId,
	formPowiatName,
	onOpenPowiatSelect,
	formWojewodztwoId,
	formWojewodztwoName,
	onOpenWojewodztwoSelect,
	formTypId,
	formTypName,
	onOpenTypSelect,
	formNip,
	setFormNip,
	isSaving,
	onClose,
	onSubmit,
}) {
	if (!isOpen) return null

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center p-4">
			<div className="absolute inset-0 bg-black/40" onClick={onClose} />
			<div className="relative w-full max-w-5xl rounded-lg bg-white shadow-xl">
				<form onSubmit={onSubmit} className="p-5">
					<h3 className="text-base font-semibold text-gray-900">
						{editingItem ? 'Edytuj placowke' : 'Dodaj placowke'}
					</h3>
					<p className="mt-1 text-sm text-gray-500">
						{editingItem ? 'Zaktualizuj dane placowki.' : 'Wprowadz dane nowej placowki.'}
					</p>

					<div className="mt-4 grid grid-cols-3 gap-x-4 gap-y-3">
						<div>
							<label htmlFor="placowka-nazwa" className="block text-sm font-medium text-gray-700">
								Nazwa
							</label>
							<input
								id="placowka-nazwa"
								type="text"
								value={formName}
								onChange={e => setFormName(e.target.value)}
								required
								autoFocus
								className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
							/>
						</div>

						<div>
							<label htmlFor="placowka-adres" className="block text-sm font-medium text-gray-700">
								Adres
							</label>
							<input
								id="placowka-adres"
								type="text"
								value={formAdres}
								onChange={e => setFormAdres(e.target.value)}
								required
								className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
							/>
						</div>

						<div>
							<label htmlFor="placowka-nip" className="block text-sm font-medium text-gray-700">
								NIP
							</label>
							<input
								id="placowka-nip"
								type="text"
								value={formNip}
								onChange={e => setFormNip(e.target.value)}
								placeholder="np. 1234567890"
								className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
							/>
						</div>

						{[
							['Miasto', onOpenMiastoSelect, formMiastoId, formMiastoName, 'Nie wybrano miasta'],
							['Gmina', onOpenGminaSelect, formGminaId, formGminaName, 'Nie wybrano gminy'],
							['Powiat', onOpenPowiatSelect, formPowiatId, formPowiatName, 'Nie wybrano powiatu'],
							[
								'Wojewodztwo',
								onOpenWojewodztwoSelect,
								formWojewodztwoId,
								formWojewodztwoName,
								'Nie wybrano wojewodztwa',
							],
							['Typ placowki', onOpenTypSelect, formTypId, formTypName, 'Nie wybrano typu placowki'],
						].map(([label, onOpen, id, name, empty]) => (
							<div key={label}>
								<div className="flex items-center justify-between gap-2">
									<label className="block text-sm font-medium text-gray-700">{label}</label>
									<button
										type="button"
										onClick={onOpen}
										className="shrink-0 rounded-md border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50">
										Wybierz z listy
									</button>
								</div>
								<div className="mt-1 min-h-10 rounded-md border border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-700">
									{id ? name || id : empty}
								</div>
							</div>
						))}
					</div>

					<div className="mt-5 flex justify-end gap-2">
						<button
							type="button"
							onClick={onClose}
							className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
							Anuluj
						</button>
						<button
							type="submit"
							disabled={
								isSaving ||
								!formName.trim() ||
								!formAdres.trim() ||
								!formMiastoId ||
								!formGminaId ||
								!formPowiatId ||
								!formWojewodztwoId ||
								!formTypId
							}
							className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-medium text-white hover:bg-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-400">
							{isSaving ? 'Zapisywanie...' : editingItem ? 'Zapisz zmiany' : 'Utworz'}
						</button>
					</div>
				</form>
			</div>
		</div>
	)
}
